import React from 'react';

const DividerBlock: React.FC = () => (
    <hr style={{ margin: '1.2rem 0', border: 'none', borderTop: '1px solid #e0e0e0' }} />
);
export default DividerBlock;
